import { reduce } from 'lodash-es';

export type InvoiceEmailData = {
  invoice_number: string;
  organization_name: string;
  billing_email: string;
  billing_phone: string;
};

export function invoiceEmailTemplateRenderer(
  text: string,
  data: InvoiceEmailData,
  renderForEmail?: boolean
): string {
  const result = reduce(
    data,
    (result, value, key) => {
      return result.replaceAll(`{{${key}}}`, value);
    },
    text
  );

  if (renderForEmail) {
    return `<div style="white-space:pre-wrap">${result}</div>`;
  }

  return result;
}
